import { render, staticRenderFns } from "./GoogleDriveDeleteFile.vue?vue&type=template&id=2ed20739&scoped=true"
import script from "./GoogleDriveDeleteFile.vue?vue&type=script&lang=js"
export * from "./GoogleDriveDeleteFile.vue?vue&type=script&lang=js"
import style0 from "./GoogleDriveDeleteFile.vue?vue&type=style&index=0&id=2ed20739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed20739",
  null
  
)

export default component.exports